module.exports = __webpack_public_path__ + "assets/b05b5d6c303ed16c1533f68c642dbe1d.png";